import {
  AppStatusIncidentSeverity,
  AppStatusIncidentStatus,
} from '@src/main/modules/app_status/domain/appStatusIncident.model';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type AppStatusOption<T> = {
  label: string;
  value: T;
};

type AppStatusOptions = {
  publicOptions: AppStatusOption<boolean>[];
  severityOptions: AppStatusOption<AppStatusIncidentSeverity>[];
  statusOptions: AppStatusOption<AppStatusIncidentStatus>[];
};

export const useAppStatusOptions = (): AppStatusOptions => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      publicOptions: [
        { label: t('common.yes'), value: true },
        { label: t('common.no'), value: false },
      ],
      severityOptions: [
        { label: t('appStatus.severity.high'), value: 'high' },
        { label: t('appStatus.severity.medium'), value: 'medium' },
        { label: t('appStatus.severity.low'), value: 'low' },
      ],
      statusOptions: [
        { label: t('appStatus.status.investigating'), value: 'investigating' },
        { label: t('appStatus.status.needsInfo'), value: 'needsInfo' },
        { label: t('appStatus.status.nextVersion'), value: 'nextVersion' },
        { label: t('appStatus.status.resolved'), value: 'resolved' },
      ],
    }),
    [t],
  );
};
